@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.popover-toggle {
  display: flex;
  align-items: center;
  margin-left: @space-4;
  cursor: pointer;

  width: 24px;
  height: 24px;
  padding: @space-4;
  border-radius: 4px;
}

.popover-toggle:hover {
  background: var(--grey-200);
}

.popover-toggle-icon {
  width: 16px;
  color: var(--grey-600);
}

.popover-content {
  width: 216px;
  background: var(--grey-100);
}

.popover-title {
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  background: var(--grey-200);
  border-bottom: 1px solid var(--grey-300);
  padding: @space-12 @space-12 @space-8;
}

.popover-body {
  padding: @space-12;
}

.popover-footer {
  padding: @space-12;
  background-color: var(--grey-200);
  border-top: 1px solid var(--grey-300);
}

.external-link-icon {
  width: 12px;
  margin-left: @space-4;
}
.external-link {
  display: flex;
}
